import { EXPORT_VARIABLE_TYPES, VARIABLE_STYLE } from "types/engineExport.types"
// Define enum for file types
export enum DATAFILE_TYPE {
  CSV = "csv",
  MAP = "map",
  JSON = "json",
  DQD = "dqd",
}

// Define type for size parameter for datafileGet - for checking if the file exists
export type DatafileSizeOption = "size" | ""

//DataFileItem interface for each data file item in the table
export interface DataFileItem {
  key: string
  fileType: string
  isUploaded: boolean
  type: DATAFILE_TYPE
}

// Define the additional values for map generation
export interface GenerateMapValues {
  groupSections?: boolean
  variableNames?: EXPORT_VARIABLE_TYPES
  variableStyle?: VARIABLE_STYLE
  includeQuestionText?: boolean
}

// Define the API response structure for generate map
export interface GenerateMapResponse {
  data: {
    result: {
      message: string
    }
  }
}

// Response type for combine data files
export interface CombineDataFilesResponse {
  data: {
    result?: {
      message?: string
      warnings?: string
    }
    // Legacy format support
    message?: string
    warnings?: string
  } | string
}

// Import method options for data import UI
export type ImportMethod = "csv_map" | "json" | "dqd"
